import { render, staticRenderFns } from "./DayCom.vue?vue&type=template&id=77dd37d0&scoped=true"
import script from "./DayCom.vue?vue&type=script&lang=js"
export * from "./DayCom.vue?vue&type=script&lang=js"
import style0 from "./DayCom.vue?vue&type=style&index=0&id=77dd37d0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77dd37d0",
  null
  
)

export default component.exports